import React, { Fragment } from 'react';

export default function Highlighter(props) {
  const { textToHighlight, searchWords = '', highlightClassName = 'highlight-bold' } = props;

  if (searchWords.length <= 1) return textToHighlight;

  const parts = textToHighlight.split(new RegExp(`(${searchWords})`, 'gi'));
  return (
    <Fragment>
      {' '}
      {parts.map((part, i) => (
        <span key={i} className={part.toLowerCase() === searchWords.toLowerCase() ? `${highlightClassName}` : ''}>
          {part}
        </span>
      ))}{' '}
    </Fragment>
  );
}
